import React from 'react';
import { XIcon, AlertTriangleIcon, ClockIcon, TruckIcon, CookingPotIcon } from 'lucide-react';
export const Problem = () => {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-288">
      <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-289">
        <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-290">
          Lo que nadie te dijo
        </h2>
        <p className="text-xl text-gray-700 mb-8" data-id="element-291">
          No es tu culpa. Es el sistema que nunca te dieron.
        </p>
      </div>
      <div className="max-w-5xl mx-auto" data-id="element-292">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-293">
          <div className="space-y-6" data-id="element-294">
            <div className="flex items-start gap-4" data-id="element-295">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-296">
                <XIcon className="h-6 w-6 text-red-600" data-id="element-297" />
              </div>
              <div data-id="element-298">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-299">
                  Comes apurado
                </h3>
                <p className="text-gray-700" data-id="element-300">
                  Sin tiempo para preparar comidas saludables
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-301">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-302">
                <TruckIcon className="h-6 w-6 text-red-600" data-id="element-303" />
              </div>
              <div data-id="element-304">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-305">
                  Recurres a comida rápida
                </h3>
                <p className="text-gray-700" data-id="element-306">Gastando más y comiendo peor</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-307">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-308">
                <CookingPotIcon className="h-6 w-6 text-red-600" data-id="element-309" />
              </div>
              <div data-id="element-310">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-311">
                  Airfryer como adorno
                </h3>
                <p className="text-gray-700" data-id="element-312">
                  Un aparato costoso que apenas usas
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-313">
              <div className="bg-red-100 p-2 rounded-full" data-id="element-314">
                <AlertTriangleIcon className="h-6 w-6 text-red-600" data-id="element-315" />
              </div>
              <div data-id="element-316">
                <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-317">
                  El verdadero problema
                </h3>
                <p className="text-gray-700" data-id="element-318">
                  No es la comida. Es el caos. Texturas flojas. Calorías
                  ocultas.
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-319">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vh7P12CLw1gsCy2YrhMWGi/e5f1bfc7-cd75-4f33-bfde-49aa6460e46b.png" alt="Desayuno saludable preparado con Airfryer" className="rounded-lg shadow-lg w-full max-w-md" data-id="element-320" />
          </div>
        </div>
      </div>
    </section>;
};